import React from "react";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Title } from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import { DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { SSH_UspItem } from "../../../../components/molecules/UspItem/UspItem.component";
import S from "./UspListV1.module.scss";

export interface V1Props {
    headline?: string;
    text?: string;
    items?: {
        content: {
            props: {
                media: { content: { props: { icon: string } } }[];
                headline: string;
                text: string;
                link?: {
                    url?: string;
                    name?: string;
                    target?: string;
                };
            };
        };
    }[];
    mobileFullWidth?: boolean;
}

const V1 = (props: V1Props) => {
    return (
        <div>
            <DA_Container className={cn(S.wrapper, props.mobileFullWidth && S.mobileFullWidth)}>
                <div className={S.list}>
                    <div className={S.uspFirst}>
                        {props.headline && (
                            <DA_Title h2 fullWidth>
                                {props.headline}
                            </DA_Title>
                        )}
                        {props.text && <DA_Text noPadding html={props.text} />}
                    </div>
                    {props.items.map((item, index) => (
                        <div key={index} className={S.listItem}>
                            <SSH_UspItem
                                className={S.uspItem}
                                icon={
                                    item.content.props.media[0].content.props.icon as DA_IconNames
                                }
                                text={item.content.props.headline}
                                subText={item.content.props.text}
                                link={item.content.props.link?.url}
                            />
                        </div>
                    ))}
                </div>
            </DA_Container>
        </div>
    );
};

export default V1;
